import { mdiUpload } from '@mdi/js';
import Icon from '@mdi/react';
import { boundMethod } from 'autobind-decorator';
import classNames from 'classnames';
import React, { Component, Fragment } from 'react';
import { Box } from 'react-layout-components';
import { t } from 'ttag';

import { UserAction } from 'uf-api';
import { DataState, getData, isLoaded } from 'uf/data/dataState';
import { events } from 'uf/layers/logging';
import { logEvent } from 'uf/logging';
import { ProjectId } from 'uf/projects';
import rootStyles from 'uf/styles/root.module.css';
import { IconSizeNew } from 'uf/ui/base/icon';
import WithTooltipButton from 'uf/ui/base/WithTooltipButton/WithTooltipButton';
import LayerImportDialog from 'uf/ui/layers/LayerImportDialog/LayerImportDialog';

interface LayerImportButtonProps {
  projectId: ProjectId;
  disabled?: boolean;
  permissionsDetails: DataState<UserAction>[];
}

interface LayerImportButtonState {
  show: boolean;
}

export default class LayerImportButton extends Component<
  LayerImportButtonProps,
  LayerImportButtonState
> {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  @boundMethod
  onCancel() {
    this.setState({ show: false });
  }
  @boundMethod
  onOk() {
    this.setState({ show: false });
  }
  @boundMethod
  onClick() {
    const { projectId } = this.props;
    logEvent(events.LAYER_IMPORT_STARTED, { projectId });
    this.setState({ show: true });
  }
  render() {
    const { projectId, disabled, permissionsDetails } = this.props;
    const { show } = this.state;
    const details =
      permissionsDetails.length && isLoaded(permissionsDetails[0])
        ? getData(permissionsDetails[0])
        : null;
    let disabledTooltipText = '';
    if (details && !details.can_do) {
      if (details.reason === 'subscription') {
        disabledTooltipText = t`Upgrade your subscription to enable this feature.`;
      } else if (details.reason === 'permission') {
        disabledTooltipText = t`This feature requires permission to make changes to the project.`;
      }
    }
    const tooltipText = (
      <Box column>
        <span>{t`Upload layer`}</span>
        {disabled && <span>{disabledTooltipText}</span>}
      </Box>
    );
    return (
      <Fragment>
        <WithTooltipButton
          id="layer-upload-button"
          tooltipText={tooltipText}
          className={classNames(rootStyles.veryThinMargin, 'LayerUploadButton')}
          disabled={disabled}
          minimal
          small
          icon={<Icon path={mdiUpload} size={IconSizeNew.SMALL} />}
          onClick={this.onClick}
        />
        <LayerImportDialog
          projectId={projectId}
          show={show}
          onOk={this.onOk}
          onCancel={this.onCancel}
        />
      </Fragment>
    );
  }
}
